import { render, staticRenderFns } from "./COM_Footer.vue?vue&type=template&id=417e9584&scoped=true&"
import script from "./COM_Footer.vue?vue&type=script&lang=js&"
export * from "./COM_Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417e9584",
  null
  
)

export default component.exports